import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';

import { routes } from './app.routes';
import { provideAuth } from './shared/helper/auth/auth.provider';
import { provideIcons } from './shared/helper/icons/icons.provider';
import {
  OAuthModule,
  OAuthService,
  UrlHelperService,
  OAuthLogger,
  DateTimeProvider,
} from 'angular-oauth2-oidc';
import { OAuthLoggerImplement } from './shared/helper/oidc-extends-class/oAuthLogger.class';
import { OAuthDateTimeProvider } from './shared/helper/oAuthDateTime.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideAuth(),
    provideIcons(),
    OAuthService,
    UrlHelperService,
    { provide: OAuthLogger, useClass: OAuthLoggerImplement },
    { provide: DateTimeProvider, useClass: OAuthDateTimeProvider },
    ...OAuthModule.forRoot().providers!,
  ],
};
